<template>
      <fiche-header :ressource="ressource"
                    @back="back"
                    @openAll="openAll"
                    @closeAll="closeAll">
      </fiche-header>
  <div class="fiche">
    <!-- Liste des sections de la fiche -->
    <v-col :class="isCardView ? 'col-7' : 'px-0'" v-if="isDisplayed('PROJET_LIST')">
        <slot name="section-projet-list">
          <section-projet-list ref="PROJET_LIST"
                               id="PROJET_LIST"
                               :extended="isExtended('PROJET_LIST')"
                               :showButton="true"
                               :autoSave="true"
                               :readOnly="readOnly"
                               :moduleId="moduleId"
                               :searchText="searchText"
                               :ressourceHeader="ressource"
                               :fiche="fiche"
                               :projet=selectedProjet
                               :route="route"
                               :attribut="attribut"
                               @extended="setExtended"
                               @fullscreen="setFullscreen"
                               @status="updateStatus"
                               @toggleCardView="toggleCardView"
                               @updated="projetUpdated"
                               @selectItem = "selectItem">
          </section-projet-list>
        </slot>
    </v-col>
  </div>
</template>
<script lang="ts">
import { defineComponent, type PropType } from "vue";
import FicheBase from '@/framework/base/components/FicheBase';
import Route from '@/extend/classes/Route';
import { CiRouter } from '@/framework/base/helpers/NavHelper'
import { Fiches } from '@/generated/classes/AppSchema';
import { Extended } from '@/framework/base/classes/Schema';
import Projet from '@/extend/classes/Projet';
import FicheHeader from '@/framework/base/components/FicheHeader.vue';
import { GenFiche, RessourceGenFiche } from '@/generated/ressources/generatedRessources';
import SectionProjetList from '@/extend/sections/SectionProjetListExtend.vue';

export default defineComponent({
  extends: FicheBase,
  components: {
    SectionProjetList,
    FicheHeader,
  },

  props: {
    projet: {
      type: Object as PropType<Projet>,
    },
  },

  created (): void {
    this.addFiches(this.sections);
  },

  data() {
    return {
      moduleId: 0,
      fiche: Fiches.PROJET_LIST,
      sections: [
        'PROJET_LIST',
      ],

    }
  },

  computed: {
    ressource () {
      return RessourceGenFiche(GenFiche.FICHE_PROJET_LIST);
    },

    selectedProjet (): Projet {
      return this.projet
    },
  },
  methods: {
    ficheMounted () {
      this.onShowSectionChanged();
      this.setFocus();
    },

    setFocus (): void {
      if (this.isMounted) {
        let res = false;
        let first = '';
        const route = CiRouter.getRoute();
        const notifSection = route ? route.section : '';
        this.sections.forEach(section => {
          // @ts-expect-error : generated method
          if (this.isDisplayed(section) && this.$refs[section] && this.$refs[section].allReadOnly && this.$refs[section].setFocus) {
            if (notifSection == section) {
              // @ts-expect-error : generated method
              this.$refs[section].setFocus(route);
              res = true;
            } else if (first == '') {
              first = section;
            }
          }
        })
        if (!res && first != '' && this.$refs[first]) {
          // @ts-expect-error : generated method
          this.$refs[first].setFocus(route);
        }
      }
    },

    // eslint-disable-next-line
    projetUpdated (projet: Projet) {
    // To implement
    },

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    isDisplayed (value: string): boolean {
      if ((!this.projet || this.projet.id < 0) && value == 'PROJET_LIST') {
        this.setExtended(new Extended('PROJET_LIST', this.fiche, true));
      }
      return true;
    }
  }
})
</script>
